<div class="reports-item-container">
  <ul class="list-inline section-menu-items adjust-width" #reportMenuBar>
    <li class="list-inline-item">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['real-time-transactions']"
        (click)="resetDropDownMenuReports()"
        routerLinkActive="router-link-active"
        *hideIfUnauthorized="'Real Time Transactions'"
      >
        {{ "pages.newRetailer.realTimeTransactions" | translate }}
      </button>
    </li>
    <li class="list-inline-item">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['transaction-summary']"
        (click)="resetDropDownMenuReports()"
        routerLinkActive="router-link-active"
        *hideIfUnauthorized="'Transaction Summary Report'"
      >
        {{ "pages.newRetailer.transactionReport" | translate }}
      </button>
    </li>
    <li class="list-inline-item">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['commision']"
        (click)="resetDropDownMenuReports()"
        routerLinkActive="router-link-active"
        *hideIfUnauthorized="'Commission Report'"
      >
        {{ "pages.newRetailer.commission" | translate }}
      </button>
    </li>

    <li class="list-inline-item"  [ngStyle]="{'display': userRole === 'Sales Rep' || userRole === 'Customer Service' ?'block':'none'}">
      <button
        mat-flat-button
        class="item-each"
        (click)="resetDropDownMenuReports()"
        [routerLink]="['invoices']"
        routerLinkActive="router-link-active"
        *hideIfUnauthorized="'Invoice Report'"
      >{{ 'pages.Invoicereport.Invoicereport' | translate}}
      </button>
    </li>


    <li class="list-inline-item"  [ngStyle]="{'display': userRole === 'Super Admin' || userRole === 'Sub Admin' || userRole === 'Admin View' || userRole === 'Billing Dept' ?'block':'none'}">
      <button
        mat-flat-button
        [matMenuTriggerFor]="menu"
        class="item-each"
        aria-label="Manage pricelist menu holder"
        routerLinkActive="router-link-active"
        #reportsButton
      >
        <span #reportsButtonTxt> {{ 'pages.Billing.Billing' | translate}} </span>
        <i matSuffix class="mi mi-arrow-drop-down float-end"></i>
      </button>
      <mat-menu #menu="matMenu">
        <a
          mat-menu-item
          [routerLink]="['payment-report']"
          routerLinkActive="router-link-active"
          (click)="onSelectPaymentReport()"
          *hideIfUnauthorized="'Payment Report'"
        >
          {{ "pages.newRetailer.paymentReport" | translate }}
        </a>
        <a
          mat-menu-item
          [routerLink]="['invoices']"
          routerLinkActive="router-link-active"
          (click)="onSelectInvoiceReport()"
          *hideIfUnauthorized="'Invoice Report'"
          >{{ 'pages.Invoicereport.Invoicereport' | translate}}
        </a>
      </mat-menu>
    </li>
    <li class="list-inline-item">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['sales-summary']"
        (click)="resetDropDownMenuReports()"
        routerLinkActive="router-link-active"
        *hideIfUnauthorized="'Sales Summary Report'"
      >
        {{ "pages.newRetailer.salesSummary" | translate }}
      </button>
    </li>
    <li class="list-inline-item">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['refund-report']"
        (click)="resetDropDownMenuReports()"
        routerLinkActive="router-link-active"
        *hideIfUnauthorized="'Refund Report'"
      >
      {{'pages.Refundreport.Refundreport' | translate }}
      </button>
    </li>    
    <li class="list-inline-item">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['retailer-acquisition']"
        (click)="resetDropDownMenuReports()"
        routerLinkActive="router-link-active"
        *hideIfUnauthorized="'Retailer Acquisition Report'"
      >
        {{ "pages.newRetailer.retailerAcquisition" | translate }}
      </button>
    </li>
    <li class="list-inline-item">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['loyalty-report']"
        (click)="resetDropDownMenuReports()"
        routerLinkActive="router-link-active"
        *hideIfUnauthorized="'Loyalty Report'"
      >
        {{ "pages.newRetailer.loyaltyReport" | translate }}
      </button>
    </li>
    <li class="list-inline-item">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['batch-export']"
        (click)="resetDropDownMenuReports()"
        routerLinkActive="router-link-active"
        *hideIfUnauthorized="'batchexport'"
      >
        {{ "pages.newRetailer.batchExport" | translate }}
      </button>
    </li>
    <!--<li class="list-inline-item">
      <button
        mat-flat-button
        style="box-shadow: none!important;"
        class="item-each shadow-none"
      >
      </button>
    </li>-->
  </ul>
  <div class="scroll-control scrl-width">
    <button
      mat-mini-fab
      id="slideLeft"
      type="button"
      class="me-3"
      (click)="onClickLeft()"
      *hideIfUnauthorized="'scrollbuttons'"
    >
      <mat-icon>arrow_left</mat-icon>
    </button>
    <button mat-mini-fab 
    id="slideRight" 
    type="button" 
    (click)="onClickRight()"
    *hideIfUnauthorized="'scrollbuttons'">
      <mat-icon>arrow_right</mat-icon>
    </button>
  </div>
  <router-outlet></router-outlet>
</div>
